import { TOUR_MODAL_CLASS } from "./constants";
import { currentPathname, isRouteActive } from "./route-matcher";
import { stepTargetProbe } from "./step-resolver";
import { resolveTargetElement } from "./target-resolver";
import type { ResolvedTourStep, TourDefinition } from "../types/tour.types";

export const hasBlockingDialog = (): boolean =>
  Boolean(document.querySelector(`[role="dialog"]:not(.${TOUR_MODAL_CLASS})`));

export const isPageSettled = (tour: TourDefinition): boolean =>
  Boolean(tour.autoStartWhen && resolveTargetElement(tour.autoStartWhen));

export const withPresentTargets = (
  steps: ResolvedTourStep[],
): ResolvedTourStep[] => {
  const pathname = currentPathname();
  return steps.filter((entry) => {
    if (entry.config.reveal) return true;
    if (!isRouteActive(entry.route, pathname)) return true;
    return Boolean(stepTargetProbe(entry.config)());
  });
};
